import MailIcon from "@mui/icons-material/Mail";
import { Box, Typography } from "@mui/material";
import type { FC } from "react";

const Office: FC = () => {
  return (
    <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
      <Box sx={{ mt: 1, ml: 2, display: "flex", flexDirection: "column" }}>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            lineHeight: 1,
            mb: 0.5,
          }}
        >
          Kontakt do działu rezerwacji
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
          <MailIcon sx={{ fontSize: 18, color: "text.secondary" }} />
          <Typography
            variant="body2"
            component="a"
            href="mailto:rezerwacje@przezmorze.pl"
            sx={{
              textDecoration: "none",
              color: "text.primary",
              "&:hover": { color: "primary.main" },
            }}
          >
            rezerwacje@przezmorze.pl
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Office;
